import { useCallback, useState } from 'react';

import { useCredentials } from '@/store/auth-store';

import type { FsTypeNavigationProps } from '.';

export function useFsTypeNavigation(fsTypeNavigationProps: FsTypeNavigationProps) {
  const { defaultTab, defaultDirectoryId, onTabChangeCallback, onDirectoryChangeCallback } = fsTypeNavigationProps;
  const { directoryId: userRootDirectoryId } = useCredentials();

  const [tab, setTab] = useState<string>(defaultTab || 'MY_DRIVE');
  const [dirId, setDirId] = useState<string | undefined>(defaultDirectoryId || userRootDirectoryId);

  const useSharedEndpoint: boolean = tab === 'SHARED_DRIVE' && dirId === undefined;

  const handleTabChange = useCallback(
    (value: string) => {
      if (value === 'SHARED_DRIVE') {
        setDirId(undefined);
      } else {
        setDirId(defaultDirectoryId || userRootDirectoryId);
      }

      setTab(value);
      onTabChangeCallback?.(value);
    },
    [defaultDirectoryId, userRootDirectoryId, onTabChangeCallback]
  );

  const handleNavigateTo = useCallback(
    (directoryId?: string) => {
      setDirId(directoryId);
      onDirectoryChangeCallback?.(directoryId);
    },
    [onDirectoryChangeCallback]
  );

  const reset = useCallback(() => {
    setTab(defaultTab || 'MY_DRIVE');
    setDirId(defaultDirectoryId || userRootDirectoryId);
  }, [defaultTab, defaultDirectoryId, userRootDirectoryId]);

  return {
    state: {
      tab,
      directoryId: dirId,
      useSharedEndpoint,
    },
    actions: {
      handleNavigateTo,
      handleTabChange,
      reset,
    },
  };
}
